import React from 'react';
import { StackProps } from 'components/stack';
import { Badge, IconButton } from '@mui/material';
import { SupportMeetingActivitiesDialog } from 'components/support-meeting-activities';
import { useOpen } from 'AurionCR/components/hooks';

import style from './index.module.scss';

interface Props extends StackProps {
  meetingID: string;
  count: number;
}

export const ColumnSupportMeetingActivities: React.FC<React.PropsWithChildren<Props>> = ({
  meetingID,
  count,
}) => {
  const { isOpen, handleOpen, handleClose } = useOpen();
  return (
    <>
      <IconButton className={style.button} onClick={handleOpen}>
        <Badge badgeContent={count} color="primary" showZero classes={{ badge: style.badge }} />
      </IconButton>
      {isOpen && (
        <SupportMeetingActivitiesDialog onClose={handleClose} supportMeetingID={meetingID} />
      )}
    </>
  );
};
